module.exports = new Promise((resolve, reject) => {
  const script = document.createElement("script");
  // Всегда используем nginx proxy путь (работает и на dev, и на production)
  script.src = `${window.location.protocol}//${window.location.host}/selection/remoteEntry.js`;
  script.onload = () => {
    const module = {
      get: (request) => window.selection.get(request),
      init: (arg) => {
        try {
          return window.selection.init(arg);
        } catch (e) {
          console.log("Selection remote has already been loaded");
        }
      },
    };
    resolve(module);
  };
  script.onerror = () => {
    reject(new Error('Selection remote init error'));
  };
  document.head.appendChild(script);
});